/*
 * ToolbarCommandButton  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { FC } from "react";
import { BEM } from "@adapptio/lib-components";
import { CommandButton, ICommandButtonProps } from "../Button/CommandButton";
import { TOOLBAR_BUTTON_SIZE } from "./ToolbarButton";

export interface ToolbarCommandButtonProps extends ICommandButtonProps {
	/** Command ID to be executed */
	commandId?: string;
	/** Optional command arguments */
	commandArgs?: unknown[];
	/** Custom style */
	style?: string;
	/** Size */
	size?: TOOLBAR_BUTTON_SIZE;
}

export const ToolbarCommandButton: FC<ToolbarCommandButtonProps> = ({ size, ...props }) => {
	const baseClass = BEM(`edt-toolbar-button-${size}`, null, {
		style: props.style
	});

	return <CommandButton {...props} baseClass={baseClass} />;
};

ToolbarCommandButton.defaultProps = {
	size: TOOLBAR_BUTTON_SIZE.DEFAULT
};
